module.exports = __webpack_public_path__ + "img/address-at.f7d5551e.svg";